import { FC } from 'react';

import Minus from '@/assets/icons/Minus';
import Plus from '@/assets/icons/Plus';
import useClientState from '@/state/useClientState';

import styles from './ZoomControl.module.css';

const ZoomControls: FC = () => {
  const setZoom = useClientState((state) => state.setZoom);
  const zoom = useClientState((state) => state.mwd.zoom);

  return (
    <div className={styles.zoomControlStyle}>
      <div>
        <button type='button' title='Zoom uit' className={styles.zoomControlButtonStyle} onClick={() => setZoom('-')}>
          <Minus width='23px' height='23px' aria-hidden='true' />
        </button>
        <button type='button' title='Zoom in' className={styles.zoomControlButtonStyle} onClick={() => setZoom('+')}>
          <Plus width='23px' height='23px' aria-hidden='true' />
        </button>
      </div>
      <div className={styles.zoomLevelStyle}>{zoom !== 100 ? `${zoom}%` : null}</div>
    </div>
  );
};
export default ZoomControls;
